import {Box, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {keyframes, styled} from '@mui/system'
import TimelineEventTemplate from 'web-common/views/timeline/TimelineEventTemplate'
import {AssistantEventProducer} from '../AssistantEventProducer'

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
`

const Dot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'delay'
})<{delay: string}>(({delay, theme}) => ({
  width: 8,
  height: 8,
  margin: 3,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  animation: `${bounce} 1.2s infinite ease-in-out`,
  animationDelay: delay
}))

interface ThinkingIndicatorProps {
  producer: AssistantEventProducer
}

interface ThinkingIndicatorState {
  showClose: boolean
}

class ThinkingIndicator extends TimelineEventTemplate<
  ThinkingIndicatorProps,
  ThinkingIndicatorState
> {
  timeout: NodeJS.Timeout | null = null

  constructor(props: ThinkingIndicatorProps) {
    super(props)
    this.state = {showClose: false}
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({showClose: true})
    }, 15000)
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  stopThinking = () => {
    this.props.producer.actionManager.enableChat()
    this.props.producer.actionManager.removeThinkingIndicator()
  }

  render() {
    return (
      <Box
        height={24}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Dot delay="0s" />
        <Dot delay="0.2s" />
        <Dot delay="0.4s" />
        {this.state.showClose && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              this.stopThinking()
            }}
            sx={{ml: 1, p: 0.5}}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    )
  }
}

export default ThinkingIndicator
